import { render, staticRenderFns } from "./MappingMID.vue?vue&type=template&id=32c4c4fb&scoped=true"
import script from "./MappingMID.vue?vue&type=script&lang=js"
export * from "./MappingMID.vue?vue&type=script&lang=js"
import style0 from "./MappingMID.vue?vue&type=style&index=0&id=32c4c4fb&prod&lang=css"
import style1 from "./MappingMID.vue?vue&type=style&index=1&id=32c4c4fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c4c4fb",
  null
  
)

export default component.exports